import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle, Compass, Home } from "lucide-react";
import { SEM_REGIAO_COR, fmtKm } from "./regiaoMapaHelpers";

// Legenda do modo "Colorir por Região": regiões (clique destaca), sem região, fora da zona sugerida e a regra do raio.
export function RegiaoLegenda({ regioes, cores, counts, semRegiao, fora, raioKm, temCentro, temPartida, highlight, setHighlight }) {
  const toggle = (k) => setHighlight(highlight === k ? null : k);
  const rowCls = (k) => `w-full flex items-center justify-between gap-2 rounded px-2 py-1 text-left hover:bg-slate-50 ${highlight === k ? "bg-orange-50 ring-1 ring-orange-300" : ""}`;
  return (
    <Card data-testid="mapa-legenda-regioes">
      <CardContent className="p-3 space-y-2">
        <div className="text-xs font-bold uppercase text-muted-foreground">Legenda — Regiões</div>
        {regioes.map((r) => (
          <button type="button" key={r.id} onClick={() => toggle(r.id)} className={rowCls(r.id)} data-testid={`mapa-legenda-regiao-${r.id}`}>
            <span className="inline-flex items-center gap-2 text-sm"><span className="w-3 h-3 rounded-full inline-block shrink-0" style={{ backgroundColor: cores[r.id] }} />{r.nome}</span>
            <span className="text-xs text-muted-foreground">{counts[r.id] || 0} bairro(s)</span>
          </button>
        ))}
        <button type="button" onClick={() => toggle("__sem__")} className={rowCls("__sem__")} data-testid="mapa-legenda-sem-regiao">
          <span className="inline-flex items-center gap-2 text-sm text-muted-foreground"><span className="w-3 h-3 rounded-full inline-block" style={{ backgroundColor: SEM_REGIAO_COR }} />Sem região</span>
          <span className="text-xs text-muted-foreground">{semRegiao} bairro(s)</span>
        </button>
        {fora > 0 && (
          <button type="button" onClick={() => toggle("__fora__")} className={`${rowCls("__fora__")} border border-amber-300 bg-amber-50/60 text-amber-900`} data-testid="mapa-legenda-fora-zona">
            <span className="inline-flex items-center gap-2 text-sm"><AlertTriangle className="w-4 h-4 text-amber-600" />Fora da zona sugerida</span>
            <span className="text-xs font-semibold">{fora} bairro(s)</span>
          </button>
        )}
        <div className="border-t pt-2 space-y-1 text-[11px] text-muted-foreground">
          {temCentro ? (
            <div className="flex items-start gap-2" data-testid="mapa-legenda-regra"><Compass className="w-3.5 h-3.5 mt-0.5 text-orange-600 shrink-0" />
              <span>Círculo tracejado = <b>Centro</b> (até {fmtKm(raioKm)} do centro da cidade); as diagonais dividem Norte / Leste / Sul / Oeste. Borda tracejada escura = bairro cuja região gravada difere da sugerida.</span>
            </div>
          ) : (
            <div className="text-amber-700">Centro da cidade não definido — use "Buscar bairros da cidade" em Bairros ou informe o Ponto de Partida.</div>
          )}
          {temPartida && <div className="flex items-center gap-2"><Home className="w-3 h-3 text-orange-600" />Ponto de partida</div>}
        </div>
      </CardContent>
    </Card>
  );
}
